exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".img-res[data-v-c4e4da1e]{display:block;height:auto}img.promo[data-v-c4e4da1e]{width:80px;height:80px;margin:20px 20px 0 0;background-repeat:no-repeat;background-size:80px;padding:1px}img.wish-hearth[data-v-c4e4da1e]{width:35px;height:35px;position:absolute;top:10px;right:10px;cursor:pointer;z-index:1}", ""]);

// exports
